import http from 'hub-http/clients/apiClient';
const CRM_SEARCH_ENDPOINT = 'crm-search/search';
export const crmSearch = query => {
  return http.post(CRM_SEARCH_ENDPOINT, {
    data: query
  });
};